/** Members the host injects; the package never imports app telemetry. */
export interface EditorHostConfig {
  /** Receives the call-site literal of a post-destroy access. The host owns dedup, caps and transport. */
  reportDestroyedEditorAccess?: (callSite: string) => void;
}

let hostConfig: EditorHostConfig = {};

/** Replaces the whole config; called once by the app bootstrap. Unset means silent. */
export function configureEditor(config: EditorHostConfig): void {
  hostConfig = { ...config };
}

export function getEditorHostConfig(): EditorHostConfig {
  return hostConfig;
}
